import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as DocumentSvg } from './assets/document.svg';

const DocumentIcon = React.forwardRef((args, ref) => <SvgIcon component={DocumentSvg} ref={ref} {...args} />);

export default DocumentIcon;
